import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/content';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const timeouts: number[] = [];
    const start = window.setTimeout(() => {
      setVisible(true);
      const interval = window.setInterval(() => {
        setVisible(false);
        timeouts.push(window.setTimeout(() => {
          setIndex(prev => (prev + 1) % purchaseNotifications.length);
          setVisible(true);
        }, 700));
      }, 9000);
      timeouts.push(interval);
    }, 5000);
    timeouts.push(start);
    return () => {
      timeouts.forEach(id => {
        window.clearTimeout(id);
        window.clearInterval(id);
      });
    };
  }, [dismissed]);
  if (dismissed) return null;
  const item = purchaseNotifications[index];
  return <div className="pointer-events-none fixed inset-x-0 top-3 z-50 flex justify-center px-3 sm:inset-x-auto sm:left-4 sm:top-auto sm:bottom-24 sm:justify-start sm:px-0" data-id="element-33" data-mp="117o35u0b6z2j">
      <AnimatePresence data-id="element-34" data-mp="1awpgtdjdt4dc">
        {visible && <motion.div initial={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -8,
        scale: 0.98
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-full max-w-sm items-start gap-3 rounded-2xl border border-navy/10 bg-white p-3 shadow-[0_12px_30px_rgba(14,35,56,0.16)]" role="status" data-id="element-35" data-mp="1ay0lrgokci61">
            <CheckCircle2Icon className="mt-0.5 h-6 w-6 shrink-0 text-forest-mid" aria-hidden="true" data-id="element-36" data-mp="28jy9ptlppfpd" />
            <div className="min-w-0 flex-1" data-id="element-37" data-mp="23lwjmopvcg4e">
              <p className="text-[13px] font-bold leading-snug text-ink" data-id="element-38" data-mp="23l3ji6lf0ov8">
                {item.name} just purchased the Clinical Kit
              </p>
              <p className="mt-0.5 text-[12px] font-medium text-ink/60" data-id="element-39" data-mp="2fn4qyf14xpw5">
                {item.place} • a few moments ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="rounded-lg p-1 text-ink/40 transition-colors duration-150 ease-out hover:bg-navy/5 hover:text-ink" data-id="element-40" data-mp="2kko4tdtx80nk">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-41" data-mp="1wxg2n4rsh7pr" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}